import { alpha, Components } from '@mui/material';
import { coastTheme } from '@vayufp/coast-components';

const divider: Components['MuiDivider'] = {
  defaultProps: {
    light: true,
  },
  styleOverrides: {
    root: {
      borderColor: alpha(coastTheme.palette.text.primary, 0.1),
    },

    light: {
      borderColor: alpha(coastTheme.palette.text.primary, 0.05),
    },
  },
};

export { divider };
